<template>
    <v-card class="ma-3 pa-5" v-if="activeProbe">
        <v-menu
            v-model="dateMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
        >
            <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    label="Start date"
                    :value="formattedDate"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    clearable
                    @click:clear="clearDate()"
                ></v-text-field>
            </template>
            <v-date-picker first-day-of-week="1" v-model="tableOptions.date" @input="dateMenu = false"></v-date-picker>
        </v-menu>
        <v-data-table
            :headers="headers"
            :items="stateHistoryData"
            :items-per-page="20"
            class="elevation-1"
            :loading="isLoading"
            loading-text="Loading state history"
            :page="tableOptions && tableOptions.page ? tableOptions.page : 1"
            :options.sync="tableOptions"
            :footer-props="footerProps"
            :server-items-length="stateHistoryDataCount"
        >
            <template v-slot:item.actions="{ item }">
                <v-btn :id="`menuActivatior-${item.id}`" color="primary" icon>
                    <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>

                <v-menu :activator="`#menuActivatior-${item.id}`">
                    <v-list>
                        <v-list-item class="menu-item" @click="handleDeleteStationState(item)">
                            <v-list-item-title>
                                <v-icon color="error" class="mr-2">mdi-trash-can-outline</v-icon>
                                Delete</v-list-item-title
                            >
                        </v-list-item>
                    </v-list>
                </v-menu>
            </template>
        </v-data-table>
    </v-card>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import moment from 'moment'
import ProbeDataService from '../../service/ProbeDataService'

export default {
    name: 'StationStatesCard',
    data() {
        return {
            tableOptions: {
                page: 1,
                itemsPerPage: 20,
                date: null,
            },
            isLoading: false,
            stateHistoryData: [],
            stateHistoryDataCount: 0,
            dateMenu: false,
            footerProps: { 'items-per-page-options': [20, 50, 100, 500] },
            headers: [
                {
                    text: 'PT Condition',
                    align: 'start',
                    sortable: false,
                    value: 'state',
                },
                {
                    text: 'Entry date',
                    align: 'start',
                    sortable: false,
                    value: 'entry_date',
                },
                {
                    text: 'Created at',
                    align: 'center',
                    sortable: false,
                    value: 'created_at',
                },

                {
                    text: '',
                    align: 'end',
                    sortable: false,
                    value: 'actions',
                },
            ],
        }
    },
    computed: {
        ...mapState('probe', ['activeProbe', 'loading']),
        formattedDate() {
            if (this.tableOptions.date) {
                return moment(this.tableOptions.date).format('DD.MM.YYYY')
            }
            return null
        },
    },
    watch: {
        activeProbe: {
            handler() {
                if (this.activeProbe) {
                    this.fetchProbeStateHistory(this.activeProbe.id)
                }
            },
            deep: true,
        },

        tableOptions: {
            handler() {
                if (this.activeProbe) {
                    this.fetchProbeStateHistory(this.activeProbe.id, this.tableOptions.date)
                }
            },
            deep: true,
        },
    },

    methods: {
        ...mapActions('probe', ['updateSensor', 'deleteProbeState']),

        async handleUpdateSensorClick(sensor) {
            await this.updateSensor(sensor)
        },
        async handleDeleteStationState(item) {
            await this.deleteProbeState(item.id)
            if (this.activeProbe) {
                await this.fetchProbeStateHistory(this.activeProbe.id)
            }
        },
        async fetchProbeStateHistory(probeId) {
            this.isLoading = true

            try {
                const resp = await ProbeDataService.getProbeStateHistory(probeId, this.tableOptions)

                if (resp.status === 200) {
                    this.stateHistoryData = resp.data?.states
                    this.stateHistoryDataCount = resp.data?.states_count
                }
            } catch (e) {
                console.log(e)
            }
            this.isLoading = false
        },
        clearDate() {
            this.tableOptions.date = null
        },
    },
}
</script>

<style scoped>
.icon-move {
    padding-right: 10px;
}
</style>
